/**
 * The Lab's **Hit shapes** switch (63.3 step 2; a presentation flag, like the fine ground's and the trees'): read from
 * `?hitshapes=1` by the game; the Lab sets the override before it launches (it starts the match in-page).
 */
let override: boolean | null = null;
/** The Lab's launch (null: back to the URL). */
export function setHitShapesShown(v: boolean | null): void { override = v; }
/** Shown: the Lab's override, else `?hitshapes=1`. */
export function hitShapesShown(): boolean {
  if (override !== null) return override;
  try { return typeof location !== 'undefined' && new URLSearchParams(location.search).get('hitshapes') === '1'; } catch { return false; }
}
